import i18next from 'eoxc/src/i18next';

export default i18next;



// WEBPACK FOOTER //
// /src/i18next.js